import React, { useEffect, useState } from 'react';


export function ErrorInfo({ onClose, errorMessage }) {
    const [isVisible, setIsVisible] = useState(true); // Controls visibility for CSS transitions
    const [shouldRender, setShouldRender] = useState(true); // Controls actual rendering
    // Handle closing with a fade-out effect
    const handleClose = () => {
        setIsVisible(false);
    };

    // Effect to trigger unmounting after the fade-out transition
    useEffect(() => {
        if (!isVisible) {
            const timer = setTimeout(() => {
                onClose(); // Perform cleanup or inform the parent component
                setShouldRender(false); // This will unmount the component after the transition
            }, 300); // Matches the CSS transition duration

            return () => clearTimeout(timer); // Clean up the timeout
        }
    }, [isVisible, onClose]);

    if (!shouldRender) {
        return null; // Ensures the component is completely unmounted from the DOM
    }


    return (
        <>
            <div id="alert-additional-content-3"
                className={`fixed top-0 left-0 right-0 z-50 flex justify-center p-4 transition-opacity duration-300 ${isVisible ? 'opacity-100' : 'opacity-0'}`}
                style={{ zIndex: 10000 }}
                role="alert">
                <div className="text-sm font-medium text-red-800 bg-red-50 border border-red-300 rounded-lg shadow-lg dark:bg-gray-800 dark:text-red-400 dark:border-red-800 p-4 mb-4"
                    style={{ zIndex: 10000 }}> {/* High z-index for visibility over other elements */}
                    <div className="flex items-center">
                        <svg className="flex-shrink-0 w-4 h-4 mr-2" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
                        </svg>
                        <span className="sr-only">Info</span>
                        <h3 className="text-lg font-medium">ERREUR</h3>
                    </div>
                    <div className="mt-2 mb-4">
                        {errorMessage}
                    </div>
                    <div className="flex">
                        <button
                            type="button"
                            onClick={handleClose}
                            aria-label="Close"
                            className="text-red-800 bg-transparent border border-red-800 hover:bg-red-900 hover:text-white focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-xs px-3 py-1.5 dark:hover:bg-red-600 dark:border-red-600 dark:text-red-400 dark:hover:text-white dark:focus:ring-red-800"
                            data-dismiss-target="#alert-additional-content-3"
                        >
                            Fermer
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}